import { AppDispatch } from "@/redux/store";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router";

import {
  evolutionsSelector,
  fetchEvolutions,
} from "../../redux/evolutions/evolutionsSlice";

const MAX_RETRIES = 2;

export const EvolutionsLayout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { status } = useSelector(evolutionsSelector);
  const retries = useRef(0);

  useEffect(() => {
    if (status === "idle") {
      retries.current = 0;
      dispatch(fetchEvolutions());
      return;
    }

    if (status === "rejected" && retries.current < MAX_RETRIES) {
      const timeoutId = setTimeout(() => {
        retries.current += 1;
        dispatch(fetchEvolutions());
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [status, dispatch]);

  return <Outlet />;
};
